import { useState } from "react"

export const useGlobalStates = () => {
    
    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')


    return Object.freeze({
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
    })
}